import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Buttons from "components/buttons/Pressed";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import Grid from "@material-ui/core/Grid";
import CloseIcon from "@material-ui/icons/Close";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useStyles } from "components/layout/CommonStyles";
import { GetNumberOfDays } from "utils/dates/GetNumberOfDays";
import DateUtils from "utils/dates/DateUtils";
import { useMutationDeleteScholarshipRecess } from "../../../hooks/DataFetching/HR/ScholarshipRecesses/useMutationDeleteScholarshipRecess";

const DialogDeleteScholarshipRecess = props => {
  if (localStorage.getItem("auth-token") !== null) {
    var auth = JSON.parse(localStorage.getItem("auth-token"));
  }

  const currentDate = new Date();
  currentDate.setHours(
    currentDate.getHours(),
    currentDate.getMinutes(),
    currentDate.getSeconds(),
    0
  );
  const classes = useStyles();
  const [t] = useTranslation();
  const { open, setOpen, item } = props;

  const [changeContext, setChangeContext] = useState(0);
  const [password, setPassword] = useState("");
  const [passwordValidated, setPasswordValidated] = useState(false);
  const [justification, setJustification] = useState("");
  const [validJustification, setValidJustification] = useState(false);
  const blankField = "GENERAL.requiredField";
  const [validPasswordrequiredField, setPasswordRequiredField] =
    useState(false);

  const handleCloseDelete = () => {
    setOpen(false);
    setValidJustification(false);
    setPasswordRequiredField(false);
    setPasswordValidated(false);
    setChangeContext(0);
    setJustification("");
    setPassword("");
  };

  var pass = true;

  const handleDelete = () => {
    if (justification.trim().length > 0) setChangeContext(old => old + 1);
    else setValidJustification(true);
    if (changeContext > 0) {
      if (password.length > 0) handleSubmit();
      else setPasswordRequiredField(true);
      if (pass) setPassword("");
      else setOpen(false);
    }
  };

  const { mutate } = useMutationDeleteScholarshipRecess(item.id);

  const handleSubmit = () => {
    const requestInfo = {
      method: "POST",
      body: JSON.stringify({
        email: auth.userName,
        password: password,
      }),
      headers: new Headers({
        "Content-type": "application/json",
      }),
    };

    fetch(process.env.REACT_APP_SERVER + "api/auth/login", requestInfo)
      .then(response => {
        if (response.ok) {
          setPasswordValidated(false);
          const payload = {
            justification: justification,
          };

          mutate(payload, {
            onSuccess: () => {
              handleCloseDelete();
            },
          });
          return false;
        } else {
          setPasswordValidated(true);
          return true;
        }
      })
      .catch(error => {
        setPasswordValidated(true);
        return true;
      });
  };

  const getDurationDateString = (startDateString, endDateString) => {
    const startDate = DateUtils.parse(startDateString);
    const endDate = DateUtils.parse(endDateString);
    const dayCount = GetNumberOfDays(startDate, endDate);
    const dayString = dayCount > 1 ? t("GENERAL.days") : t("GENERAL.day");
    return `${DateUtils.format(startDate, "DD/MM/YYYY")} - ${DateUtils.format(
      endDate,
      "DD/MM/YYYY"
    )} (${dayCount} ${dayString})`;
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleCloseDelete}
        aria-labelledby="form-dialog-title"
        msg="mensagem"
        fullWidth
        maxWidth={"sm"}
      >
        <DialogTitle className={classes.Title}>
          <b>{t("GENERAL.delete") + " " + t("HR.recessPeriod")}</b>
          <IconButton
            style={{
              float: "right",
              marginTop: -10,
              marginRight: -17,
            }}
            edge="end"
            color="inherit"
            onClick={handleCloseDelete}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {changeContext === 0 ? (
            <DialogContentText>
              <p>{t("HR.deleteMessageRecessRegistration")}</p>

              <Grid container item spacing={0} md={12} lg={12}>
                <Grid item xs={12} sm={6}>
                  <b>{t("HR.operatedBy").toUpperCase()}</b>
                  <div>{item.operator ?? "-"}</div>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <b>{t("GENERAL.period").toUpperCase()}</b>
                  <div>
                    {item.startDate && item.endDate
                      ? getDurationDateString(item.startDate, item.endDate)
                      : "-"}
                  </div>
                </Grid>
              </Grid>
              <TextField
                error={validJustification}
                multiline
                fullWidth
                variant="outlined"
                rows="3"
                value={justification}
                label={t("INVENTORY.justification") + "*"}
                margin="normal"
                inputProps={{ maxLength: 100 }}
                helperText={
                  validJustification
                    ? t(blankField)
                    : `${justification.length}/100`
                }
                onChange={e => {
                  setValidJustification(false);
                  setJustification(e.target.value);
                }}
              />
            </DialogContentText>
          ) : (
            <DialogContentText>
              <p>{t("HR.deleteMessageRecessRegistrationPassword")}</p>
              <TextField
                error={validPasswordrequiredField || passwordValidated}
                label={t("INVENTORY.password") + "*"}
                value={password}
                onChange={e => {
                  setPasswordRequiredField(false);
                  setPasswordValidated(false);
                  setPassword(e.target.value);
                }}
                type="password"
                variant="filled"
                helperText={
                  validPasswordrequiredField
                    ? t(blankField)
                    : passwordValidated
                    ? "Senha inválida."
                    : ""
                }
                style={{
                  width: "90%",
                  marginLeft: 30,
                  marginRight: 30,
                }}
              />
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <Buttons
            onClick={handleCloseDelete}
            tipo="BN-noback"
            conteudo={t("GENERAL.cancel").toUpperCase()}
          />
          <Buttons
            onClick={handleDelete}
            tipo="BN-blue"
            conteudo={
              changeContext === 0
                ? t("GENERAL.next").toUpperCase()
                : t("GENERAL.delete").toUpperCase()
            }
          />
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default DialogDeleteScholarshipRecess;
